import { Loader2, type LucideIcon } from 'lucide-react';

export interface OpcionRolVista {
  key: string;
  label: string;
  description: string;
  icon: LucideIcon;
}

interface ListaOpcionesRolProps<T extends OpcionRolVista> {
  opciones: T[];
  onSelect: (opcion: T) => void;
  /** key de la opción en proceso (muestra spinner y bloquea el resto). */
  seleccionando?: string | null;
}

/**
 * Lista de botones del selector de portal/rol del login. Compartida con el
 * diálogo "Cambiar de rol" para que ambos se vean igual.
 */
export function ListaOpcionesRol<T extends OpcionRolVista>({
  opciones,
  onSelect,
  seleccionando = null,
}: ListaOpcionesRolProps<T>) {
  return (
    <div className="space-y-3">
      {opciones.map((opcion) => {
        const Icon = opcion.icon;
        const enProceso = seleccionando === opcion.key;
        return (
          <button
            key={opcion.key}
            type="button"
            onClick={() => onSelect(opcion)}
            disabled={seleccionando !== null}
            className="w-full flex items-center gap-4 px-5 py-4 rounded-xl border-2 text-left transition-all hover:shadow-md disabled:cursor-wait disabled:opacity-70"
            style={{
              borderColor: 'hsl(0 0% 90%)',
              background: 'hsl(0 0% 100%)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'hsl(145 40% 50%)';
              e.currentTarget.style.background = 'hsl(145 40% 97%)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'hsl(0 0% 90%)';
              e.currentTarget.style.background = 'hsl(0 0% 100%)';
            }}
          >
            <div
              className="flex items-center justify-center w-11 h-11 rounded-xl flex-shrink-0"
              style={{ background: 'hsl(145 40% 94%)' }}
            >
              {enProceso ? (
                <Loader2 className="h-5 w-5 animate-spin" style={{ color: 'hsl(145 40% 35%)' }} />
              ) : (
                <Icon className="h-5 w-5" style={{ color: 'hsl(145 40% 35%)' }} />
              )}
            </div>
            <div>
              <div className="font-bold text-sm text-[hsl(0_0%_5%)]">{opcion.label}</div>
              <div className="text-xs mt-0.5" style={{ color: 'hsl(0 0% 50%)' }}>{opcion.description}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
